import { Group } from '@mantine/core'
import React from 'react'

import fechar from '../../../icones/iconesVersaoEscura/fechar_janela.svg'
import ellipseVerde from '../../../icones/iconesVersaoVerde/ellipse.svg'
import { limparFiltr } from '../../../utils/alternanciaIcones'
import ActionIcon from '../ActionIcon'
import Botao from '../Botao'

import * as S from './styles'

/**
 * @typedef {'filtro' | 'alerta' | 'default'} ModalType
 * @typedef {'center' | 'left'} PositionTitle
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'auto'} SizeType
 *
 * @typedef {Object} ModalProps
 * @property {React.ReactNode} titulo
 * @property {PositionTitle} [positionTitle='left']
 * @property {ModalType} [type='default']
 * @property {React.ReactNode} children
 * @property {SizeType} [size='auto']
 * @property {string | number} [width]
 * @property {string | number} [minHeight]
 * @property {boolean} [opened]
 * @property {() => void} close
 * @property {() => void} [onConfirm]
 * @property {() => void} [handleCleanFilters]
 * @property {boolean} [disableConfirm=false]
 * @property {boolean} [withCloseButton=true]
 * @property {boolean} [showActionsModal=true]
 * @property {boolean} [disableElipse=false]
 * @property {boolean} [hasIcon=false]
 * @property {React.ReactNode} [icon]
 * @property {boolean} [useWhiteTheme=false]
 * @property {boolean} [closeOnClickOutside=true]
 */

/**
 * @param {ModalProps} props
 */
export default function Modal({
  titulo,
  positionTitle = 'left',
  type = 'default',
  children,
  size = 'auto',
  width,
  minHeight,
  opened,
  close,
  onConfirm,
  handleCleanFilters,
  disableConfirm = false,
  withCloseButton = true,
  showActionsModal = true,
  disableElipse = false,
  hasIcon = false,
  icon,
  useWhiteTheme = false,
  closeOnClickOutside = true
}) {
  const isFiltro = type === 'filtro'
  const isAlerta = type === 'alerta'
  const isDefault = type === 'default'
  const mostrarCloseButton = withCloseButton && !isFiltro && !isAlerta

  return (
    <S.ModalMantine
      useWhiteTheme={useWhiteTheme}
      type={type}
      width={width}
      minHeight={minHeight}
      size={size}
      closeOnClickOutside={closeOnClickOutside && !isAlerta}
      opened={opened}
      onClose={close}
      withCloseButton={mostrarCloseButton}
      closeButtonProps={{
        children: (
          <img
            className="botao-fechar-janela-icone"
            src={fechar}
            alt="fechar-janela"
          />
        )
      }}
      title={
        <S.TituloWrapper type={type}>
          {titulo && (
            <>
              {positionTitle === 'center' && (
                <S.TituloCenter>
                  {hasIcon && (
                    <S.BlankSlateWrapper>
                      <ActionIcon
                        alt="info"
                        scaleIcon={3}
                        variant="transparent"
                        icon={icon}
                      />
                    </S.BlankSlateWrapper>
                  )}
                  <S.TituloModal useWhiteTheme={useWhiteTheme}>
                    {titulo}
                  </S.TituloModal>
                </S.TituloCenter>
              )}
              {positionTitle === 'left' && (
                <S.Titulo>
                  {!disableElipse && (
                    <S.Elipse src={ellipseVerde} alt="elipse" />
                  )}
                  <S.TituloModal useWhiteTheme={useWhiteTheme}>
                    {titulo}
                  </S.TituloModal>
                </S.Titulo>
              )}
            </>
          )}

          {isFiltro ? (
            <S.BotoesFiltroWrapper>
              <Botao
                label={
                  <S.LimparFiltroLabelWrapper onClick={handleCleanFilters}>
                    <span>LIMPAR FILTROS</span>
                    <img src={limparFiltr()} alt="fechar-janela" />
                  </S.LimparFiltroLabelWrapper>
                }
                variant="unstyled"
              />
              <Botao label="Filtrar" variant="primary" onClick={onConfirm} />
              <Botao label="Voltar" variant="outline" onClick={close} />
            </S.BotoesFiltroWrapper>
          ) : null}
        </S.TituloWrapper>
      }
      centered
    >
      {children}

      {showActionsModal && isDefault && (
        <Group position="center">
          <Botao label="Cancelar" variant="outline" onClick={close} />
          <Botao
            label="Confirmar"
            variant="primary"
            disabled={disableConfirm}
            onClick={onConfirm}
          />
        </Group>
      )}
    </S.ModalMantine>
  )
}
